export const group = {
    labels: {
        name: "Nome",
        group: "Grupo",
        groups: "Grupos",
        description: "Descrição",
        add_group: "Adicionar Grupo",
        delete_group: "Deletar Grupo",
        edit_group: "Editar Grupo",
        slug: "Slug",
    },
    placeholders: {
        name: "Informe o nome",
        description: "Informe a descrição",
        slug: "Exe: nome-da-url",
    },
    modals: {
        titles: {
            add_group: "Adicionar Grupo",
            del_group: "Excluir Grupo",
        },
        messages: {
            del_group: "Você deseja mesmo excluir grupo <strong>{name}</strong>?<br/>Todos os cadastros deste grupo serão excluídos.",
        },
    },
    texts: {
    },
};
